export const PAGE_CONFIG: Record<
  'pc' | 'mobile',
  {
    htmlClass: string;
    bodyClass: string;
    viewportContent: string;
  }
> = {
  pc: {
    htmlClass: 'chat_html_pc',
    bodyClass: 'chat_pc',
    viewportContent: 'width=device-width, initial-scale=1',
  },
  mobile: {
    htmlClass: 'chat_html_mobile',
    bodyClass: 'chat_mobile',
    viewportContent: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
  },
};
